import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import classNames from 'classnames'

import './Chosen.scss'

const Chosen = ({
  value,
  name,
  className,
  isDisabled,
  isLoading,
  isMulti,
  isSearchable,
  onChange,
  options,
  handleUndefinedValue,
  placeholder,
  isClearable,
  noResultsText,
  limitSearch,
  limitSearchText,
  isInvalid,
  label,
  labelRequired,
  extraLinkLabel,
  extraLinkCallback,
  invalidMessage,
  notes,
  onInputChange,
  onInputReset,
  filterOptionMethod,
  onBlur
}) => {
  const flattenedOptions = options.reduce((accumulator, currentValue) => {
    return currentValue.hasOwnProperty('options') && Array.isArray(currentValue.options)
      ? [...accumulator, ...currentValue.options]
      : [...accumulator, currentValue]
  }, [])

  const srcValue = Array.isArray(value) ? value : [value]

  const selectedValue = srcValue.map((singleValue) => {
    return flattenedOptions.find((singleOption) => {
      return singleOption.value === singleValue
    })
  })

  const chosenOptions = [
    ...(handleUndefinedValue ? [
      {
        label: placeholder,
        value: undefined
      }
    ] : []),
    ...options
  ]

  if (limitSearch) {
    chosenOptions.push({ label: limitSearchText, disabled: true })
  }

  const filterOption = (filterOptionMethod === 'contains') ? null : filterOptionStartsWith

  const classContainer = classNames(className, {
    'react_select__container-invalid': isInvalid,
    'react_select__container--handle-undefined': handleUndefinedValue
  })

  return (
    <div className={classContainer}>
      {label &&
        <div className='row-label'>
          <label>{label}</label>
          {labelRequired && <strong> *</strong>}
          {extraLinkLabel && <a className='textlink-extra-light f-right' onClick={extraLinkCallback}>{extraLinkLabel}</a>}
        </div>}
      <div className='row m-bottom-0'>
        <Select
          name={name}
          filterOption={filterOption}
          value={selectedValue}
          options={chosenOptions}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isSearchable={isSearchable}
          isMulti={isMulti}
          onChange={onChange}
          placeholder={placeholder}
          isClearable={isClearable}
          noOptionsMessage={() => noResultsText}
          imitSearch={limitSearch}
          limitSearchText={limitSearchText}
          isOptionDisabled={(option) => option.disabled}
          isInvalid={isInvalid}
          className='react_select__container'
          classNamePrefix='react_select'
          onInputChange={onInputChange}
          onMenuOpen={onInputReset}
          onBlur={onBlur}
        />
      </div>
      {isInvalid && isInvalid && <div className='row m-bottom-0'><p className='input_is-required_text'>{invalidMessage}</p></div>}
      {notes && <div className='row m-bottom-0'><p className='input-note'>{notes}</p></div>}
    </div>
  )

  function filterOptionStartsWith (option, raw) {
    const search = raw.trim().toLowerCase()
    return option.label.toLowerCase().split(/\s+/).some(word => word.startsWith(search))
  }
}

Chosen.defaultProps = {
  isLoading: false,
  isMulti: false,
  isDisabled: false,
  isClearable: false,
  limitSearch: false,
  limitSearchText: '',
  isInvalid: false,
  labelRequired: false,
  isSearchable: true,
  filterOptionMethod: 'startsWith',
  invalidMessage: ''
}

Chosen.propTypes = {
  // value: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  classNames: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSearchable: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  noResultsText: PropTypes.string,
  limitSearch: PropTypes.bool,
  limitSearchText: PropTypes.string,
  isInvalid: PropTypes.bool,
  label: PropTypes.string,
  labelRequired: PropTypes.bool,
  extraLinkLabel: PropTypes.string,
  extraLinkCallback: PropTypes.func,
  invalidMessage: PropTypes.string,
  notes: PropTypes.string,
  filterOptionMethod: PropTypes.oneOf(['startsWith', 'contains'])
}

export default Chosen
